<template>
  <el-container class="pikpak-layout">
    <el-aside width="240px" class="aside-wrapper">
      <div class="aside-inner">
        <div class="logo-box">
          <router-link to="/disk" class="logo-link">
            <img src="@/assets/img/logo.png" class="logo" alt="logo">
            <span class="logo-text">disk</span>
          </router-link>
        </div>

        <el-menu
          :default-active="$route.path"
          router
          class="side-menu"
        >
          <el-menu-item index="/disk/file">
            <i class="el-icon-folder" />
            <span slot="title">我的文件</span>
          </el-menu-item>
          <el-menu-item index="/disk/photo">
            <i class="el-icon-picture-outline" />
            <span slot="title">我的相册</span>
          </el-menu-item>
          <el-menu-item index="/disk/cam">
            <i class="el-icon-video-camera" />
            <span slot="title">我的监控</span>
          </el-menu-item>
          <el-menu-item index="/disk/share">
            <i class="el-icon-share" />
            <span slot="title">我的分享</span>
          </el-menu-item>
          <el-menu-item index="/disk/me">
            <i class="el-icon-user" />
            <span slot="title">我的</span>
          </el-menu-item>
        </el-menu>

        <div class="aside-footer">
          <div class="quota-info">
            <div class="quota-text">已用 1.2GB / 6TB</div>
            <el-progress :percentage="20" :show-text="false" :stroke-width="4" />
          </div>
          <el-dropdown trigger="click" class="user-dropdown">
            <div class="avatar-wrapper">
              <img :src="user ? user.avatarUrl : ''" class="user-avatar" alt="">
              <span class="username">{{ user ? user.name : '未登录' }}</span>
              <i class="el-icon-more" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-setting" @click.native="showSettingDialog = true">设置</el-dropdown-item>
              <el-dropdown-item icon="el-icon-back" @click.native="goToLogout">登出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-aside>

    <el-main class="main-content">
      <div class="content-card">
        <transition name="page-fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </div>
    </el-main>

    <el-dialog
      title="系统设置"
      :visible.sync="showSettingDialog"
      width="500px"
      append-to-body
      custom-class="setting-dialog"
    >
      <div class="setting-content">
        <el-form label-position="top">
          <el-form-item label="离线下载通知">
            <el-switch
              v-model="settingForm.enableNotify"
              active-text="开启"
              inactive-text="关闭"
              @change="handleNotifyChange"
            />
          </el-form-item>
          <el-form-item label="外观设置">
            <el-radio-group v-model="settingForm.theme" size="small">
              <el-radio-button label="light">浅色模式</el-radio-button>
              <el-radio-button label="dark">深色模式</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="默认视图">
            <el-select v-model="settingForm.defaultView" placeholder="请选择" style="width: 100%">
              <el-option label="列表视图" value="list" />
              <el-option label="网格视图" value="grid" />
            </el-select>
          </el-form-item>
          <el-form-item label="语言">
            <el-select v-model="settingForm.lang" style="width: 100%">
              <el-option label="简体中文" value="zh" />
              <el-option label="English" value="en" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSettingDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings">保 存</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { submitActivity } from '@/api/disk'

export default {
  name: 'Disk',
  mixins: [userMixin],
  data() {
    return {
      user: null,
      showSettingDialog: false,
      settingForm: {
        enableNotify: false,
        theme: 'light',
        defaultView: 'list',
        lang: 'zh'
      }
    }
  },
  created() {
    this.user = this.$store.state.userInfo
  },
  methods: {
    handleNotifyChange(val) {
      submitActivity().then(resp => {
        this.$message.info(resp.msg)
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    saveSettings() {
      this.$message.success('设置已保存')
      this.showSettingDialog = false
    }
  }
}
</script>

<style scoped>
/* 整体布局背景 */
.pikpak-layout {
  height: 100vh;
  background-color: #f8f9fa; /* 极浅灰背景 */
}

/* 侧边栏样式 */
.aside-wrapper {
  background-color: #fff;
  border-right: 1px solid #f0f0f0;
  padding: 20px 0;
}

.aside-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.logo-box {
  padding: 0 24px 30px;
  display: flex;
  align-items: center;
}

.logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.logo-text {
  margin-left: 12px;
  font-size: 20px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.add-btn {
  width: 100%;
  border-radius: 12px; /* 大圆角 */
  padding: 12px;
  font-weight: bold;
  font-size: 15px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 菜单样式微调 */
.side-menu {
  border-right: none !important;
  flex-grow: 1;
}

.side-menu .el-menu-item {
  height: 48px;
  line-height: 48px;
  margin: 4px 12px;
  border-radius: 10px;
  color: #5f6368;
}

.side-menu .el-menu-item.is-active {
  background-color: #e8f0fe !important;
  color: #1a73e8;
  font-weight: bold;
}

.side-menu .el-menu-item i {
  font-size: 20px;
  margin-right: 12px;
}

/* 侧边栏底部 */
.aside-footer {
  padding: 20px 16px;
  border-top: 1px solid #f0f0f0;
}

.quota-info {
  margin-bottom: 20px;
  padding: 0 8px;
}

.quota-text {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.avatar-wrapper:hover {
  background: #f5f5f5;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.username {
  flex-grow: 1;
  font-size: 14px;
  color: #333;
}

/* 内容区卡片化 */
.main-content {
  padding: 20px;
  display: flex;
}

.content-card {
  background: #fff;
  width: 100%;
  border-radius: 20px; /* 大圆角内容区 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.02);
  padding: 24px;
  overflow-y: auto;
}

/* 动画效果 */
.page-fade-enter-active, .page-fade-leave-active {
  transition: opacity 0.2s ease;
}
.page-fade-enter, .page-fade-leave-to {
  opacity: 0;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .aside-wrapper {
    display: none; /* 移动端通常改为抽屉或底部导航 */
  }
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none; /* 移除 router-link 默认的下划线 */
  color: inherit;       /* 继承文字颜色 */
  cursor: pointer;
}

/* 弹窗圆角美化 */
::v-deep .setting-dialog {
  border-radius: 16px;
}

::v-deep .setting-dialog .el-dialog__header {
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .setting-dialog .el-dialog__title {
  font-weight: bold;
  font-size: 16px;
}

.setting-content {
  padding: 10px 0;
}

/* 调整表单间距 */
.setting-content .el-form-item {
  margin-bottom: 15px;
}
</style>
